import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule, LazyImport } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "GroupList" */ './lazyIndex'),
    {
        name: 'GroupList',
    }
);

// Delay loaded actions
export const lazyUnsubscribeFromUnreadNotifications: LazyAction<
    typeof lazyIndex.unsubscribeFromUnreadNotifications,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.unsubscribeFromUnreadNotifications);

export const lazyLoadGroupAccountSources: LazyAction<
    typeof lazyIndex.loadGroupAccountSources,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.loadGroupAccountSources);

export const lazyLoadGroupAccountSourcesForCurrentSession: LazyAction<
    typeof lazyIndex.loadGroupAccountSourcesForCurrentSession,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.loadGroupAccountSourcesForCurrentSession);

export const lazyDoesGroupSmtpExistInLeftNav: LazyImport<
    typeof lazyIndex.doesGroupSmtpExistInLeftNav,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.doesGroupSmtpExistInLeftNav);

export const lazyDropMailListRowsOnGroup: LazyAction<
    typeof lazyIndex.dropMailListRowsOnGroup,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.dropMailListRowsOnGroup);
